import { apiCallback } from '@vantiva-sa/homesight_humaui/Services/Common';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { useSelector } from 'react-redux';
import { useApiMutation } from './useApiMutation';

const useGetUserEventsMutation = (options = {}) => {
  const trans = useSelector(translator);
  const userEventsApi = useSelector((state) => state.apis.userEventsApi);

  return useApiMutation(
    ({
      useruuid,
      startDate,
      endDate,
      eventTypes = [],
      deviceuuid,
      successCallback = () => {},
      errorCallback = () => {},
    }) =>
      new Promise((resolve, reject) => {
        userEventsApi.userDeviceEventsByTypesAndTimeRange(
          useruuid,
          startDate,
          endDate,
          { eventtypes: eventTypes, deviceuuid: [deviceuuid] },
          apiCallback({
            translator: trans,
            successCallback: (data) => {
              successCallback(data['user_events'] || []);
              resolve(data['user_events'] || []);
            },
            errorCallback: (err) => {
              console.error(
                `Error fetching ${eventTypes.join(',')} events data for deviceuuid ${deviceuuid}: `,
                err
              );
              errorCallback(err);
              reject(err);
            },
            failCallback: (err) => {
              console.error(
                `Failed to fetch ${eventTypes.join(',')} events data for deviceuuid ${deviceuuid}: `,
                err
              );
              errorCallback(err);
              reject(err);
            },
          })
        );
      }),
    { ...options }
  );
};

export default useGetUserEventsMutation;
